module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono@2x-3de0794e8d22ec8ac2f476150fed1424.webp";